import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Error404 = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/login", { replace: true });
    }, 800); // small delay (optional)
  }, [navigate]);

  return <div className="redirecting">Redirecting to login…</div>;
};

export default Error404;
